/* Import node_modules packages JavaScript */
import 'jquery';
import 'popper.js'
import 'bootstrap'
// import 'chart.js'
import 'datatables.net'
import 'datatables.net-bs4'
import 'select2'
import 'jquery-toast-plugin/src/jquery.toast'
import Echo from 'laravel-echo';
import Translator from 'gettext-translator';

// Import TinyMCE
import tinymce from 'tinymce/tinymce';

// Any plugins you want to use has to be imported
import 'tinymce/plugins/paste';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/image';
import 'tinymce/plugins/link';
import 'tinymce/plugins/table';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/help';

// Initialize the app
// tinymce.init({
//     selector: '.tinymce-editor',
//     theme_url: '/assets/tinymce/themes/silver/theme.js',
//     skin_url: '/assets/tinymce/skins/ui/oxide',
//     skin: 'oxide',
//     content_css: '/assets/tinymce/skins/content/default/content.css',
//     language_url : '/assets/tinymce/langs/' + window.CONFIG.currentLocale + '.js',
//     language: window.CONFIG.currentLocale,
//     branding: false,
//     plugins: ['print', 'preview', 'searchreplace', 'autolink', 'visualblocks', 'visualchars', 'fullscreen',
//         'image', 'link', 'media', 'table', 'charmap', 'hr', 'nonbreaking', 'anchor', 'advlist', 'lists',
//         'wordcount', 'imagetools', 'help'],
//     toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat',
//
//     // toolbar: "wordcount",
//     height: 500
// });

window.jQuery = $;
window.$ = $;

window.CONFIG.CSRF_TOKEN = getMeta('csrf-token');

const t = new Translator(window.CONFIG.translations);
window.t = t;

window.io = require('socket.io-client');

// window.Echo = new Echo({
//     broadcaster: 'socket.io',
//     host: window.CONFIG.laravelEcho.host + ':' + window.CONFIG.laravelEcho.port
// });

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.CONFIG.laravelEcho.key,
    wsHost: window.location.hostname,
    wsPort: window.CONFIG.laravelEcho.wsPort,
    wssPort: window.CONFIG.laravelEcho.wssPort,
    wsPath: window.CONFIG.laravelEcho.wsPath,
    encrypted: window.CONFIG.laravelEcho.encrypted,
    disableStats: true,
    enabledTransports: ['ws', 'wss']
});

window.showNotification = function (message, type, time = 8000) {
    $('.jq-toast-wrap').removeClass('bottom-left bottom-right top-left top-right mid-center'); // to remove previous position class
    $('.jq-toast-wrap').css({"top": "", "left": "", "bottom":"", "right": ""}); // to remove previous position style
    $.toast({
        heading: message,
        showHideTransition: 'fade',
        icon: type,
        position: 'bottom-right',
        hideAfter: time,
        loader: false
    })
};

window.userHasPermission = function (permission) {
    return window.CONFIG.user.is_superuser || window.CONFIG.user.permissions.includes(permission);
};

window.userHasOneOfPermissions = function (permissions) {
    for (let i = 0; i < permissions.length; i++) {
        if (window.userHasPermission(permissions[i])) {
            return true;
        }
    }
    return false;
};

/* Import application JavaScript */
require('./victory/off-canvas.js');
require('./victory/hoverable-collapse.js');
require('./victory/misc.js');
require('./vue/main.js');

function getMeta(metaName) {
    const metas = document.getElementsByTagName('meta');
    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }
    return '';
}


$(document).ready(function () {

    $.fn.modal.Constructor.prototype.enforceFocus = function () {};

    // Redirect to logout after session expire
    if (window.CONFIG.user.sessionLifetime !== -1) {
        setTimeout(function() {
            window.location.reload();
        }, window.CONFIG.user.sessionLifetime * 60000 + 1000);
    }

    $.extend( true, $.fn.dataTable.defaults, {
        language: {
            'decimal':        ',',
            'emptyTable':     t.__('Brak danych'),
            'info':           t.__('Pozycje od _START_ do _END_ z _TOTAL_ łącznie'),
            'infoEmpty':      t.__('Pozycji 0 z 0 dostępnych'),
            'infoFiltered':   t.__('(filtrowanie spośród _MAX_ dostępnych pozycji)'),
            'infoPostFix':    '',
            'thousands':      ' ',
            'lengthMenu':     t.__('Pokaż _MENU_ pozycji'),
            'loadingRecords': t.__('Wczytywanie...'),
            'processing':     '<div><span>' + t.__('Przetwarzanie...') + '</span></div>',
            'search':         t.__('Szukaj:'),
            'zeroRecords':    t.__('Nie znaleziono pasujących pozycji'),
            'paginate': {
                'first':      t.__('Pierwsza'),
                'last':       t.__('Ostatnia'),
                'next':       t.__('Następna'),
                'previous':   t.__('Poprzednia')
            },
            'aria': {
                'sortAscending':  t.__(': aktywuj, by posortować kolumnę rosnąco'),
                'sortDescending': t.__(': aktywuj, by posortować kolumnę malejąco')
            }
        }
    });

    /*
    * DataTables
    *
    * */
    let dataTable = $('.data-table-processing');

    if (dataTable.length) {
        dataTable.on('processing.dt', function(e, settings, processing) {
            if (processing === false) {
                showContent();
            }
        })
    } else {
        showContent();
    }

    /**
     * Custom file input
     *
     * */
    $('.custom-file-input').on('change', function() {
        let fileName = $(this).val().split('\\').pop();
        $(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

});

$(window).on('resize', function() {
    applyMenu();
});

function applyMenu() {
    $('.navbar-brand-wrapper, .navbar-menu-wrapper, #sidebar, .content-wrapper').addClass('notransition');
    if ($(window).width() < 1600) {
        $('body').addClass('sidebar-icon-only');
    } else {
        $('body').removeClass('sidebar-icon-only');
    }
    setTimeout(function() {
        $('.navbar-brand-wrapper, .navbar-menu-wrapper, #sidebar, .content-wrapper').removeClass('notransition');
    }, 250);
}

function showContent() {
    applyMenu();
    $('.content-hide').css('visibility', 'visible').animate({opacity: 1}, 500, function () {
        $('.content-hide').removeClass('content-hide');
        $('body').css('overflow', 'auto');
    });
    $('.loader').fadeOut();
    $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
}

$('.apply-select2').select2({
    language: 'pl'
});

$(document).on('show.bs.modal', '#delete-modal', function(e){
    $(this).find('form').attr('action', $(e.relatedTarget).data('url'));
});
